export const GroupParamType = {
    SPACE: 'space',
    STATUS: 'status',
    MATERIAL: 'material',
    SECTION: 'section',
    CUSTOMIZE: 'customize',
}